import { IIdName } from "../../Types/CommonTypes";
import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { SearchLedgerByGroupsTypes } from "./LedgerService";

export interface IAgeingListParams {
  toDate: string;
  type: AgeingReportTypes;
  useDueDate: boolean;
  filterType: AgeingFilterType;
  numberOfSlabs: number;
  periods: number;
  sortCol?: string;
  sortDir?: string;
}

export enum AgeingReportTypes {
  Debtors,
  Creditors,
}

export enum AgeingFilterType {
  Month = 0,
  Weeks = 1,
  Days = 2,
}

export interface IAgeingInvoices {
  date: string;
  number: string;
  due: number;
}

export interface IAgeingReportRange {
  id: number;
  amount: number;
  invoices?: IAgeingInvoices[];
}

export interface IAgeingReport {
  contact: IIdName;
  prepayments: number;
  ranges: IAgeingReportRange[];
  totalDue: number;
  creditLimit: number;
  availableCredit: number;
}

export interface IAgeingResponse {
  items: IAgeingReport;
  totalPrepayments: number;
  totalCreditLimit: number;
  totalAvailableCredit: number;
  totalDueAmt: number;
  rangeTotals: { id?: number; name?: number | string }[];
}

export enum Statements {
  None,
  Trading = 1,
  ProfitAndLoss,
  BalanceSheet,
}

export enum GroupList_Type {
  All,
  HaveBalanceOnly,
}
class New_Reports {
  route = `V1/API/Billing/Acc_Reports`;

  getTrialBalanceReport = (
    companyId: string,
    includeOpening: true,
    fromDate: string,
    toDate: string
  ) =>
    ApiUtility.getResult(
      `${this.route}/${companyId}/TrialBalance?fromDate=${fromDate}&toDate=${toDate}&includeOpening=${includeOpening}`
    );

  //https://localhost:7142/V1/API/ACC_Reports/65cdd05235241f48a55de738/ProfitAndLoss?fromDate=04-03-2024&toDate=07-03-2024

  getGroupHierarchy = (
    companyId: string,
    fromDate?: string,
    toDate?: string,
    groupId?: string,
    groupListType?: GroupList_Type,
    ledgersByGroupSelType?: SearchLedgerByGroupsTypes,
    Statements?: number
  ) =>
    ApiUtility.getResult(`${this.route}/${companyId}/GetGroupHierarchy`, {
      fromDate,
      toDate,
      groupId,
      Statements,
      groupListType,
      ledgersByGroupSelType,
    });
  //https://localhost:7142/v1/API/New_Reports/65cdd05235241f48a55de738/GetFinalStatement

  getFinalStatement = (companyId: string, statement: Statements) =>
    ApiUtility.getResult(`${this.route}/${companyId}/GetFinalStatement`, {
      statement,
    });

  getGeneralReport = (
    companyId: string,
    fromDate: string,
    toDate: string,
    groupId?: string | "",
    searchLedger?: string | ""
  ) =>
    ApiUtility.get(
      `${this.route}/${companyId}/GetGeneralReport?fromDate=${fromDate}&toDate=${toDate}&groupId=${groupId}&searchLedger=${searchLedger}`
    );

  getGSTR1 = (
    companyId: string | undefined,
    fromdate: string,
    toDate: string
  ) => {
    return ApiUtility.get(
      `${this.route}/${companyId}/GetGSTR1?fromDate=${fromdate}&toDate=${toDate}`
    );
  };
  getGSTR2A = (
    companyId: string | undefined,
    fromdate: string,
    toDate: string
  ) => {
    return ApiUtility.get(
      `${this.route}/${companyId}/GetGSTR2A?fromDate=${fromdate}&toDate=${toDate}`
    );
  };
  getGSTR3B = (
    companyId: string | undefined,
    fromdate: string,
    toDate: string
  ) => {
    return ApiUtility.get(
      `${this.route}/${companyId}/GetGSTR3B?fromDate=${fromdate}&toDate=${toDate}`
    );
  };

  getAgeingReport = (companyId: string, params: IAgeingListParams) => {
    return ApiUtility.get(`${this.route}/${companyId}/Ageing`, params);
  };

  getPartyOutstandingReports = (
    companyId: string | undefined,
    fromdate: string,
    toDate: string,
    ledgerId?: string | "",
    partyType?: any
  ) => {
    return ApiUtility.get(
      `${this.route}/${companyId}/GetPartyOutstandingReport?fromDate=${fromdate}&toDate=${toDate}&ledgerId=${ledgerId}&partyType=${partyType}`
    );
  };
}

export default new New_Reports();
